import { render, staticRenderFns } from "./AdvantagesObjectEdit.vue?vue&type=template&id=36c94116&scoped=true&lang=pug&"
import script from "./AdvantagesObjectEdit.vue?vue&type=script&lang=js&"
export * from "./AdvantagesObjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesObjectEdit.vue?vue&type=style&index=0&id=36c94116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c94116",
  null
  
)

export default component.exports